import axios from 'axios';

const extractMessageFromResponse = (data: any): string | undefined => {
  if (!data) {
    return undefined;
  }

  if (typeof data === 'string') {
    return data;
  }

  if (typeof data === 'object') {
    if (typeof data.message === 'string' && data.message.trim()) {
      return data.message.trim();
    }
    if (typeof data.error === 'string' && data.error.trim()) {
      return data.error.trim();
    }
  }

  return undefined;
};

const getApiErrorMessage = (error: unknown, fallbackMessage?: string): string => {
  let apiMessage: string | undefined;

  if (axios.isAxiosError(error)) {
    apiMessage = extractMessageFromResponse(error.response?.data) || error.message;
  } else if (error instanceof Error) {
    apiMessage = error.message;
  } else if (typeof error === 'string') {
    apiMessage = error;
  }

  if (fallbackMessage && apiMessage) {
    return `${fallbackMessage} (${apiMessage})`;
  }

  return apiMessage || fallbackMessage || '알 수 없는 오류가 발생했습니다.';
};

export default getApiErrorMessage;
